type PropsType = {

}

const Music: React.FC<PropsType> = (props) => {
    return (
        <div>
            Music
        </div>
    );
}

export default Music;